const namespace = "customLeftNav";

import AppConfig from "@/_config/application-config"
import childRoutes from "./routes"
import BrowserStorage from "@/_util/storage-modes.browser-storage";

const localStorage = new BrowserStorage(namespace);
const sessionStorage = new BrowserStorage(namespace, true);

const appConfig = {
  // "namespace" : {
  name: "Custom Left Navigation",
  namespace,
  description: null,
  version: "0.1.0",
  icon: "mdi-gauge",
  parentRoute: "/custom-left-nav",
  defaultRoute: "home",
  accentColor: "#000080",
  childRoutes,
  component : () => import(/* webpackChunkName: "custom-left-nav" */ "@/apps/custom-left-nav/Application.vue"),
  //Global Nav
  navigation: [
    {
      icon: "mdi-home",
      title: "Home",
      route: "home",
    },
    {
      icon: "mdi-view-module",
      title: "Test Page",
      route: "testpage",
    },
    {
      icon: "mdi-cog",
      title: "Settings",
      route: "config",
    },
    {
      icon: "mdi-help",
      title: "App Help Page",
      route: "apphelp",
    },      
    {
      icon: "mdi-help",
      title: "Global Help",
      route: "help",
    },  
  ],  
  settings: {
    appNavigation: [
      {
        icon: "mdi-home",
        text: "Home",
        link: "/custom-left-nav/home",
        roles: []
      },
      {
        icon: "mdi-view-module",
        text: "Test Page",
        link: "/custom-left-nav/testpage",
      },
      {
        icon: "mdi-view-module",
        text: "Test Fields - long title to be shortened",
        link: "/custom-left-nav/testfields",
      },      
      {
        icon: "mdi-cog",
        text: "Settings",
        link: "/custom-left-nav/config",
        roles: ["admin", "masterDataTeam"]
      },
      {
        icon: "mdi-help",
        text: "Help",
        link: "/custom-left-nav/apphelp",
        value: false,
        items: [ 
                {
                  icon: "mdi-help",
                  text: "Google Help - external Link",
                  link: "http://google.com",
                  newWindow: true
                },
                {
                  icon: "mdi-help",
                  text: "Global Help",
                  link: "/custom-left-nav/help",
                }               
              ],
      },
      {
        icon: "mdi-cog",
        text: "Test Group",
        link: "/custom-left-nav/apphelp",
        roles: ["masterDataTeam"],
        items: [ 
                {
                  icon: "mdi-cog",
                  text: "Test 1 Page",
                  link: "/custom-left-nav/apphelp",
                },
                {
                  icon: "mdi-cog",
                  text: "Test 2 Page",
                  link: "/custom-left-nav/help",
                },  
              ],
      },
    ],
    environment : "DEV",
    //api_url: "https://as-gimoapi-stg.azurewebsites.net/",
     //clientId: "d9fa34dc-c004-4bd3-8d69-89abb343df5b",
     //clientId: "38f1b253-537f-4d01-8f87-58726a6c6621",
     //scope: "api://d9fa34dc-c004-4bd3-8d69-89abb343df5b/Read.All",
     clientId: "cd31724b-d289-4d5a-ba95-f9fd1088ee85",
     scope: "api://cd31724b-d289-4d5a-ba95-f9fd1088ee85/Read.All",
    //  authorizeUrl: "https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/authorize",
    //  tokenUrl: "https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/token",
    //  logoutUrl: `https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/logout?post_logout_redirect_uri=${window.location.origin}`,
     authorizeUrl:
      "https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/authorize",
     tokenUrl:
      "https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/token",
     //logoutUrl:
      //"https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/logout?post_logout_redirect_uri=https://localhost:8080",
    logoutUrl: `https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/logout?post_logout_redirect_uri=${encodeURIComponent(window.location.origin + '/')}`,
    redirect_uri: window.location.origin,
    
    env_color_dev: { "r": 96, "g": 125, "b": 139, "a": 1 }, 
    env_color_stg: { "r": 38, "g": 166, "b": 154, "a": 1 },
  },
  store: {
    //The store is made up of settings and attributes that should be accessible across components.
    //One common scenario would be user settings or profile preferences.  Some examples:
    //Date and Time Formats
    //Preferred configuration of a table view
    //Preferred theme color.
    themeColor : {
      default: "red",
      storageMode : localStorage,
    },
    isTrue : {
      default: true,
      storageMode : sessionStorage,
    },
    userDetails: {
      default: {},
      storageMod: localStorage,
    }
  }

}

export default AppConfig.merge(appConfig);


